module.exports = __webpack_public_path__ + "img/formplus.5f5cbd5e.svg";